// The v3 snippet queues identify, track, and ready until the SDK loads.
// getAnonymousId exists only on the loaded client.
function readClient() {
  return window.rudderanalytics ?? null;
}

/**
 * RudderStack treats these as two different payloads:
 * - identify(traits) → user properties (context.traits + People profile).
 * - track(event, properties) → event properties. Mixpanel device mode only shows
 *   this object as "Your Properties"; context.traits do not appear there.
 *
 * @type {import('./index').AnalyticsDestination & import('./index').AnalyticsIdentityProvider}
 */
export const rudderStackAdapter = {
  track(event, properties) {
    readClient()?.track(event, properties);
  },

  identify(traits) {
    readClient()?.identify(traits);
  },

  whenAnonymousId() {
    return new Promise((resolve) => {
      const rudder = readClient();

      if (typeof rudder?.ready !== 'function') {
        resolve(null);
        return;
      }

      // Never resolves when the snippet is blocked; callers own the timeout.
      rudder.ready(() => resolve(readClient()?.getAnonymousId?.() ?? null));
    });
  }
};
